import axios from 'axios';
import api from '@src/api';
import cloneDeep from 'lodash/cloneDeep';

export const state = {
  AllClientProgram: [],
  selectedWeek: null,
  selectedAllWeek: null,
  selectedDay: null,
  duplicateToWeekNumber: null,
  programDay: null,
  dragModalCtx: null,
};

export const getters = {};

export const mutations = {
  setProgramDay(state, value) {
    state.programDay = value;
  },

  setAllClientProgram(state, value) {
    if (value.length > 0) {
      const sortedWeeks = value.sort(function(a, b) {
        if (a.weekNumber < b.weekNumber) {
          return -1;
        }
        if (a.weekNumber > b.weekNumber) {
          return 1;
        }
        return 0;
      });
      state.AllClientProgram = sortedWeeks;
    } else {
      state.AllClientProgram = [];
    }
  },
  setSelectedWeek(state, value) {
    state.selectedWeek = value;
  },
  setSelectedAllWeek(state, value) {
    state.selectedAllWeek = value;
  },
  setSelectedDay(state, value) {
    state.selectedDay = value;
  },
  setUpdateWeekItem(state, value) {
    const i = state.AllClientProgram.findIndex(
      (week) => week.weekNumber === value.weekNumber
    );
    const programClone = cloneDeep(state.AllClientProgram);
    programClone[i] = value;
    state.AllClientProgram = programClone;
  },
  setUpdateProgramDayInWeek(state, value) {
    const programClone = cloneDeep(state.AllClientProgram);
    const weekClone = cloneDeep(state.selectedWeek);
    const weekIndex = programClone.findIndex(
      (week) => week.weekNumber === weekClone.weekNumber
    );
    const dayIndex = weekClone.days.findIndex(
      (day) => day.dayNumber === value.dayNumber
    );
    value.workouts[0].hasWorkout = true;
    programClone[weekIndex].days[dayIndex].workouts[0] = value.workouts[0];
    state.AllClientProgram = programClone;
  },
  setUpdateProgramWorkout(state, value) {
    const programDayClone = cloneDeep(state.selectedDay);
    if (value.programWorkout_id) {
      const i = programDayClone.workouts.findIndex(
        (workout) => workout.programWorkout_id === value.programWorkout_id
      );
      programDayClone.workouts[i] = value;
    } else {
      programDayClone.workouts[0] = value;
    }
    state.selectedDay = programDayClone;
  },
  setUpdateProgramWorkoutExerciseSet(state, value) {
    const programDayClone = cloneDeep(state.programDay);
    const workout = programDayClone.workouts[0];
    const setDirections =
      workout.circuits[value.circuitIndex].exercises[value.exerciseIndex]
        .setDirections;
    value.type === 'add'
      ? setDirections.push(value.setDirections)
      : setDirections.pop();
    state.programDay = programDayClone;
  },
  setUpdateProgramWorkoutExerciseSetReps(state, value) {
    const programDayClone = cloneDeep(state.programDay);
    const workout = programDayClone.workouts[0];
    const circuit = workout.circuits[value.circuitIndex];
    const exercise = circuit.exercises[value.exerciseIndex];
    const setDirections = exercise.setDirections[value.exerciseSetIndex];
    setDirections.reps = value.count;
    state.programDay = programDayClone;
  },
  setUpdateProgramWorkoutExerciseSetTime(state, value) {
    const programDayClone = cloneDeep(state.programDay);
    const workout = programDayClone.workouts[0];
    const circuit = workout.circuits[value.circuitIndex];
    const exercise = circuit.exercises[value.exerciseIndex];
    const setDirections = exercise.setDirections[value.exerciseSetIndex];
    setDirections.time = value.count;
    state.programDay = programDayClone;
  },
  setUpdateProgramWorkoutExerciseSetWeight(state, value) {
    const programDayClone = cloneDeep(state.programDay);
    const workout = programDayClone.workouts[0];
    const circuit = workout.circuits[value.circuitIndex];
    const exercise = circuit.exercises[value.exerciseIndex];
    const setDirections = exercise.setDirections[value.exerciseSetIndex];
    setDirections.weight = value.count;
    state.programDay = programDayClone;
  },
  setUpdateProgramWorkoutExerciseSetRest(state, value) {
    const programDayClone = cloneDeep(state.programDay);
    const workout = programDayClone.workouts[0];
    const circuit = workout.circuits[value.circuitIndex];
    const exercise = circuit.exercises[value.exerciseIndex];
    const setDirections = exercise.setDirections[value.exerciseSetIndex];
    setDirections.afterSetRest = value.count;
    state.programDay = programDayClone;
  },
  setUpdateProgramWorkoutCircuitIntro(state, value) {
    const programDayClone = cloneDeep(state.programDay);
    const workout = programDayClone.workouts[0];
    const circuit = workout.circuits[value.circuitIndex];
    const intro = circuit.trainerFeedback.intro;
    intro.text = value.intro;
    state.programDay = programDayClone;
  },
  setUpdateProgramWorkoutCircuitOutro(state, value) {
    const programDayClone = cloneDeep(state.programDay);
    const workout = programDayClone.workouts[0];
    const circuit = workout.circuits[value.circuitIndex];
    const intro = circuit.trainerFeedback.outro;
    intro.text = value.outro;
    state.programDay = programDayClone;
  },
  setMoveProgramNote(state, value) {
    const AllClientProgramClone = cloneDeep(state.AllClientProgram);
    const {
      targetedDataClone: {
        day: { dayIndex: targetDayIndex },
        week: { weekIndex: targetWeekIndex },
      },
      destinationDataClone: {
        day: { dayIndex: destinationDayIndex },
        week: { weekIndex: destinationWeekIndex },
      },
    } = value;

    const fromNote =
      AllClientProgramClone[targetWeekIndex].days[targetDayIndex]
        .dayHasTrainerNote;

    const toNote =
      AllClientProgramClone[destinationWeekIndex].days[destinationDayIndex]
        .dayHasTrainerNote;

    // swap
    AllClientProgramClone[targetWeekIndex].days[
      targetDayIndex
    ].dayHasTrainerNote = toNote;
    AllClientProgramClone[destinationWeekIndex].days[
      destinationDayIndex
    ].dayHasTrainerNote = fromNote;
    state.AllClientProgram = AllClientProgramClone;
  },
  setMoveProgramCheckin(state, value) {
    const AllClientProgramClone = cloneDeep(state.AllClientProgram);
    const {
      targetedDataClone: {
        day: { dayIndex: targetDayIndex },
        week: { weekIndex: targetWeekIndex },
      },
      destinationDataClone: {
        day: { dayIndex: destinationDayIndex },
        week: { weekIndex: destinationWeekIndex },
      },
    } = value;
    const [fromCheckIn] = cloneDeep(
      AllClientProgramClone[targetWeekIndex].days[targetDayIndex].checkIns
    );

    const [toCheckIn] = cloneDeep(
      AllClientProgramClone[destinationWeekIndex].days[destinationDayIndex]
        .checkIns
    );
    // swap
    AllClientProgramClone[targetWeekIndex].days[
      targetDayIndex
    ].checkIns[0] = toCheckIn;
    AllClientProgramClone[destinationWeekIndex].days[
      destinationDayIndex
    ].checkIns[0] = fromCheckIn;
    state.AllClientProgram = AllClientProgramClone;
  },
  setMoveProgramWorkout(state, value) {
    const AllClientProgramClone = cloneDeep(state.AllClientProgram);

    const targetWeekIndex = value.targetedDataClone.week.weekIndex;
    const targetDayIndex = value.targetedDataClone.day.dayIndex;
    const toWorkout = cloneDeep(
      AllClientProgramClone[targetWeekIndex].days[targetDayIndex].workouts[0]
    );

    const destinationWeekIndex = value.destinationDataClone.week.weekIndex;
    const destinationDayIndex = value.destinationDataClone.day.dayIndex;
    const fromWorkout =
      value && value.type && value.type === 'reverse'
        ? cloneDeep(
            AllClientProgramClone[destinationWeekIndex].days[
              destinationDayIndex
            ].workouts[0]
          )
        : cloneDeep({
            hasWorkout: false,
            label: '',
            mediaAssets: {
              coverPhoto: { url: '' },
            },
            timeToComplete: 0,
            clientInput: {
              startedAt: '',
              completedAt: '',
              workoutProgress: {
                totalWorkoutElements: 0,
                completedWorkoutElements: 0,
                circuitIndex: 0,
                exerciseIndex: 0,
                workoutDurationSeconds: 0,
              },
              postWorkoutReview: {
                remainingEnergyPercent: 0,
                progressTowardsGoal: 0,
                workoutSatisfaction: 0,
                anyOtherFeedback: '',
              },
            },
          });

    AllClientProgramClone[destinationWeekIndex].days[
      destinationDayIndex
    ].workouts[0] = toWorkout;
    AllClientProgramClone[targetWeekIndex].days[
      targetDayIndex
    ].workouts[0] = fromWorkout;

    state.AllClientProgram = AllClientProgramClone;
  },
  setDragModalCtx(state, value) {
    state.dragModalCtx = value;
  },
};

export const actions = {
  getProgramWeeks(ctx, { orgId, trainerId, userId }) {
    if (orgId !== undefined && trainerId !== undefined) {
      const url = api.URL_GET_PROGRAM_WEEKS.replace(':orgID', orgId)
        .replace(':trainerID', trainerId)
        .replace(':userID', userId);

      return axios
        .get(url)
        .then((res) => {
          ctx.commit('setAllClientProgram', res.data.programWeeks);
          return res.data;
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        `invalid params (orgId, trainerId, userId) : (${orgId}, ${trainerId}, ${userId})`
      );
    }
  },

  getProgramRange(ctx, programObj) {
    const url = api.URL_GET_PROGRAM_RANGE.replace(':programID', programObj.id)
      .replace(':FROM', programObj.from)
      .replace(':TO', programObj.to);

    // Minimum data check for obj
    if (
      programObj.id !== undefined &&
      programObj.from !== undefined &&
      programObj.to !== undefined
    ) {
      return axios
        .get(url)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            ctx.commit('setAllClientProgram', res.data.programWeeks);
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'programObj must contain the following properties to be a valid replacement [ id, from, to ]',
        programObj
      );
    }
  },

  getAllClientProgram(ctx, programObj) {
    const url = api.URL_GET_ALL_CLIENT_PROGRAM.replace(
      ':programID',
      programObj.id
    )
      .replace(':FROM', programObj.from)
      .replace(':TO', programObj.to)
      .replace(':TODAY', programObj.today);

    // Minimum data check for obj
    if (
      programObj.id !== undefined &&
      programObj.from !== undefined &&
      programObj.to !== undefined &&
      programObj.today !== undefined
    ) {
      return axios
        .get(url)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            ctx.commit('setAllClientProgram', res.data.programWeeks);
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'programObj must contain the following properties to be a valid replacement [ id, from, to, today ]',
        programObj
      );
    }
  },

  addUpdateWorkoutDay(ctx, workoutDayObj) {
    const url = api.URL_ADD_UPDATE_WORKOUT_DAY.replace(
      ':programID',
      workoutDayObj.programId
    );
    // Minimum data check for obj
    if (
      workoutDayObj.programId &&
      workoutDayObj.payload.source &&
      workoutDayObj.payload.programDestination &&
      workoutDayObj.payload.source.type !== undefined &&
      workoutDayObj.payload.source.programWorkout !== undefined &&
      workoutDayObj.payload.programDestination.weekNumber !== undefined &&
      workoutDayObj.payload.programDestination.dayNumber !== undefined
    ) {
      const payload = { ...workoutDayObj.payload };
      return axios
        .post(url, payload)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            // Here we check if moving a workout and the same week
            // to solve showing workout will be deleted after creating the new one
            // This issue appears only if we're moving in the same week
            if (workoutDayObj.action === 'move' && workoutDayObj.sameWeek) {
              const weekIndex = workoutDayObj.targetedDataClone.week.weekIndex;
              const dayIndex = workoutDayObj.targetedDataClone.day.dayIndex;
              const emptyWorkout =
                ctx.state.AllClientProgram[weekIndex].days[dayIndex]
                  .workouts[0];
              const programWeekClone = cloneDeep(res.data.programWeek);
              programWeekClone.days[dayIndex].workouts[0] = emptyWorkout;
              ctx.commit('setUpdateWeekItem', programWeekClone);
            } else {
              ctx.commit('setUpdateWeekItem', res.data.programWeek);
            }
            return res;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'workoutDayObj must contain the following properties to be a valid replacement [ type, programWorkout_id, programWorkout, weekNumber, dayNumber ]',
        workoutDayObj
      );
    }
  },

  deleteWorkoutDay(ctx, workoutDayObj) {
    let url = '';
    if (!workoutDayObj.isCustom) {
      url = api.URL_DELETE_WORKOUT_DAY.replace(
        ':programID',
        workoutDayObj.programId
      )
        .replace(':weekID', workoutDayObj.weekId)
        .replace(':dayID', workoutDayObj.dayId)
        .replace(':workoutID', workoutDayObj.workoutId);
    } else {
      url = api.URL_DELETE_CUSTOM_WORKOUT_DAY.replace(
        ':programID',
        workoutDayObj.programId
      )
        .replace(':weekID', workoutDayObj.weekId)
        .replace(':dayID', workoutDayObj.dayId);
    }

    // Minimum data check for obj
    if (
      workoutDayObj.programId !== undefined &&
      workoutDayObj.weekId !== undefined &&
      workoutDayObj.dayId !== undefined &&
      (workoutDayObj.isCustom || workoutDayObj.workoutId !== undefined)
    ) {
      return axios
        .delete(url)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            if (workoutDayObj && !workoutDayObj.type) {
              ctx.commit('setUpdateWeekItem', res.data.programWeek);
            }
            return res;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'workoutDayObj must contain the following properties to be a valid replacement [ programId, weekId, dayId, workoutId ]',
        workoutDayObj
      );
    }
  },

  getAllDay(ctx, dayObj) {
    const url = api.URL_GET_ALL_DAY.replace(':dayID', dayObj.dayId)
      .replace(':orgID', dayObj.orgId)
      .replace(':trainerID', dayObj.trainerId)
      .replace(':userID', dayObj.userId);

    // Minimum data check for obj
    if (
      dayObj.orgId !== undefined &&
      dayObj.dayId !== undefined &&
      dayObj.trainerId !== undefined &&
      dayObj.userId !== undefined
    ) {
      return axios
        .get(url)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            ctx.commit('setProgramDay', res.data.programDay);
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'dayObj must contain the following properties to be a valid replacement [ dayId, trainerId, orgId, userId ]',
        dayObj
      );
    }
  },

  addUpdateTrainerNote(ctx, trainerNoteObj) {
    const url = api.URL_ADD_UPDATE_TRAINER_NOTE.replace(
      ':programID',
      trainerNoteObj.programId
    );
    // Minimum data check for obj
    if (
      trainerNoteObj.programId &&
      trainerNoteObj.payload.source &&
      trainerNoteObj.payload.programDestination &&
      trainerNoteObj.payload.source.type !== undefined &&
      trainerNoteObj.payload.source.message !== undefined &&
      trainerNoteObj.payload.programDestination.weekNumber !== undefined &&
      trainerNoteObj.payload.programDestination.dayNumber !== undefined
    ) {
      const payload = { ...trainerNoteObj.payload };

      return axios
        .post(url, payload)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            // Here we check if moving a workout and the same week
            // to solve showing workout will be deleted after creating the new one
            // This issue appears only if we're moving in the same week
            if (trainerNoteObj.action === 'move' && trainerNoteObj.sameWeek) {
              const { weekIndex, dayIndex } = trainerNoteObj;
              const noNote =
                ctx.state.AllClientProgram[weekIndex].days[dayIndex]
                  .dayHasTrainerNote;
              const programWeekClone = cloneDeep(res.data.programWeek);
              programWeekClone.days[dayIndex].dayHasTrainerNote = noNote;
              ctx.commit('setUpdateWeekItem', programWeekClone);
            } else {
              ctx.commit('setUpdateWeekItem', res.data.programWeek);
            }
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'trainerNoteObj must contain the following properties to be a valid replacement [ programId, type, message, weekNumber, dayNumber ]',
        trainerNoteObj
      );
    }
  },

  deleteTrainerNote(ctx, trainerNoteObj) {
    const url = api.URL_DELETE_TRAINER_NOTE.replace(
      ':programID',
      trainerNoteObj.programId
    )
      .replace(':weekID', trainerNoteObj.weekId)
      .replace(':dayID', trainerNoteObj.dayId);

    // Minimum data check for obj
    if (
      trainerNoteObj.programId !== undefined &&
      trainerNoteObj.weekId !== undefined &&
      trainerNoteObj.dayId !== undefined
    ) {
      return axios
        .delete(url)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            ctx.commit('setUpdateWeekItem', res.data.programWeek);
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'trainerNoteObj must contain the following properties to be a valid replacement [ programId, weekId, dayId ]',
        trainerNoteObj
      );
    }
  },

  addUpdateCheckin(ctx, checkinObj) {
    const url = api.URL_ADD_CHECKIN_DAY.replace(
      ':programID',
      checkinObj.programId
    );

    // Minimum data check for obj
    if (
      checkinObj.programId &&
      checkinObj.payload.source &&
      checkinObj.payload.programDestination &&
      checkinObj.payload.source.type !== undefined &&
      checkinObj.payload.programDestination.weekNumber !== undefined &&
      checkinObj.payload.programDestination.dayNumber !== undefined
    ) {
      const payload = { ...checkinObj.payload };

      return axios
        .post(url, payload)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            // Here we check if moving a checkin and the same week
            // to solve showing checkin will be deleted after creating the new one
            // This issue appears only if we're moving in the same week
            if (checkinObj.action === 'move' && checkinObj.sameWeek) {
              const weekIndex = checkinObj.targetedDataClone.week.weekIndex;
              const dayIndex = checkinObj.targetedDataClone.day.dayIndex;
              const emptyWorkout =
                ctx.state.AllClientProgram[weekIndex].days[dayIndex]
                  .checkIns[0];
              const programWeekClone = cloneDeep(res.data.programWeek);
              programWeekClone.days[dayIndex].checkIns[0] = emptyWorkout;
              ctx.commit('setUpdateWeekItem', programWeekClone);
            } else {
              ctx.commit('setUpdateWeekItem', res.data.programWeek);
            }
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'checkinObj must contain the following properties to be a valid replacement [ programId, type, weekNumber, dayNumber ]',
        checkinObj
      );
    }
  },

  deleteCheckinDay(ctx, checkinObj) {
    const url = api.URL_DELETE_CHECKIN_DAY.replace(
      ':programID',
      checkinObj.programId
    )
      .replace(':weekID', checkinObj.weekId)
      .replace(':dayID', checkinObj.dayId)
      .replace(':checkinID', checkinObj.checkinId);

    // Minimum data check for obj
    if (
      checkinObj.programId !== undefined &&
      checkinObj.weekId !== undefined &&
      checkinObj.dayId !== undefined &&
      checkinObj.checkinId !== undefined
    ) {
      return axios
        .delete(url)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            ctx.commit('setUpdateWeekItem', res.data.programWeek);
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'trainerNoteObj must contain the following properties to be a valid replacement [ programId, weekId, dayId ]',
        checkinObj
      );
    }
  },

  duplicateToADay(ctx, duplicationObj) {
    const url = api.URL_DUPLICATE_DAY.replace(
      ':programID',
      duplicationObj.toProgramId
    );

    // Minimum data check for obj
    if (
      duplicationObj.toProgramId &&
      duplicationObj.payload.source &&
      duplicationObj.payload.programDestination &&
      duplicationObj.payload.source.program_id !== undefined &&
      duplicationObj.payload.source.weekNumber !== undefined &&
      duplicationObj.payload.source.dayNumber !== undefined &&
      duplicationObj.payload.programDestination.weekNumber !== undefined &&
      duplicationObj.payload.programDestination.dayNumber !== undefined
    ) {
      const payload = { ...duplicationObj.payload };

      return axios
        .post(url, payload)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            ctx.commit('setUpdateWeekItem', res.data.programWeek);
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'duplicationObj must contain the following properties to be a valid replacement [ toProgramId, source.program_id, source.weekNumber, source.dayNumber, programDestination.weekNumber, programDestination.dayNumber ]',
        duplicationObj
      );
    }
  },

  duplicateToAWeek(ctx, duplicationObj) {
    const url = api.URL_DUPLICATE_WEEK.replace(
      ':programID',
      duplicationObj.toProgramId
    );

    // Minimum data check for obj
    if (
      duplicationObj.toProgramId &&
      duplicationObj.payload.source &&
      duplicationObj.payload.programDestination &&
      duplicationObj.payload.source.program_id !== undefined &&
      duplicationObj.payload.source.weekNumber !== undefined &&
      duplicationObj.payload.programDestination.weekNumber !== undefined
    ) {
      const payload = { ...duplicationObj.payload };
      return axios
        .post(url, payload)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            ctx.commit('setUpdateWeekItem', res.data.programWeek);
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'duplicationObj must contain the following properties to be a valid replacement [ toProgramId, source.program_id, source.weekNumber, programDestination.weekNumber ]',
        duplicationObj
      );
    }
  },

  clearAllDayEvents(ctx, dayObj) {
    const url = api.URL_CLEAR_ALL_DAY_EVENTS.replace(
      ':programID',
      dayObj.programId
    )
      .replace(':weekID', dayObj.weekId)
      .replace(':dayID', dayObj.dayId);
    // Minimum data check for obj
    if (
      dayObj.programId !== undefined &&
      dayObj.weekId !== undefined &&
      dayObj.dayId !== undefined
    ) {
      return axios
        .delete(url)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            ctx.commit('setUpdateWeekItem', res.data.programWeek);
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'dayObj must contain the following properties to be a valid replacement [ programId, weekId, dayId ]',
        dayObj
      );
    }
  },

  clearAllWeekEvents(ctx, weekObj) {
    const url = api.URL_CLEAR_ALL_WEEK_EVENTS.replace(
      ':programID',
      weekObj.programId
    ).replace(':weekID', weekObj.weekId);

    // Minimum data check for obj
    if (weekObj.programId !== undefined && weekObj.weekId !== undefined) {
      return axios
        .delete(url)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            ctx.commit('setUpdateWeekItem', res.data.programWeek);
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'weekObj must contain the following properties to be a valid replacement [ programId, weekId ]',
        weekObj
      );
    }
  },

  clearAllClientProgram(ctx, programId) {
    const url = api.URL_CLEAR_ALL_PROGRAM.replace(':programID', programId);

    // Minimum data check for obj
    if (programId !== undefined) {
      return axios
        .delete(url)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error('programId must be a valid replacement', programId);
    }
  },

  updateProgramDay(ctx, dayObj) {
    const url = api.URL_UPDATE_PROGRAM_DAY.replace(
      ':dayID',
      dayObj.programDay._id
    )
      .replace(':orgID', dayObj.programDay.org_id)
      .replace(':trainerID', dayObj.programDay.trainer_id)
      .replace(':userID', dayObj.programDay.user_id);

    const payload = { programDay: dayObj.programDay };
    // Minimum data check for obj
    if (
      dayObj.programDay.org_id !== undefined &&
      dayObj.programDay._id !== undefined &&
      dayObj.programDay.trainer_id !== undefined &&
      dayObj.programDay.user_id !== undefined &&
      dayObj.programDay !== undefined
    ) {
      return axios
        .post(url, payload)
        .then((res) => {
          if (res.data.success === false) {
            return res.data.error;
          } else {
            ctx.commit('setProgramDay', res.data.programDay);
            ctx.commit('setUpdateProgramDayInWeek', res.data.programDay);
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'dayObj.programDay must contain the following properties to be a valid replacement [ _id, trainer_id, org_id, user_id ]',
        dayObj.programDay
      );
    }
  },

  overrideClientProgram(ctx, programObj) {
    const url = api.URL_OVERRIDE_CLIENT_PROGRAM.replace(
      ':programID',
      programObj.desProgramId
    );

    const payload = { ...programObj.overridePayload };
    // Minimum data check for obj
    if (
      programObj.desProgramId !== undefined &&
      programObj.overridePayload.source &&
      programObj.overridePayload.source.program_id !== undefined &&
      programObj.overridePayload.programDestination.weekNumber !== undefined &&
      programObj.overridePayload.programDestination.today !== undefined
    ) {
      return axios
        .post(url, payload)
        .then((res) => {
          if (res.data.error) {
            return res.data.error;
          } else {
            ctx.commit('setProgramDay', res.data.programWeeks);
            return res.data;
          }
        })
        .catch((err) => {
          console.warn(err);
        });
    } else {
      console.error(
        'dayObj must contain the following properties to be a valid replacement [ dayId, trainerId, orgId, userId, programDay ]',
        programObj
      );
    }
  },
};
